export const audienceSubscriptionTypeFilter = ["both", "email", "sms"] as const;
export type AudienceSubscriptionTypeFilter =
  (typeof audienceSubscriptionTypeFilter)[number];
